export default "__VITE_ASSET__DVIMPY5U__"